import React, { useEffect } from "react";
import InfoComponent from "./InfoComponent";
import { t } from "../../locales/translate";
import { useLocation } from "react-router-dom";

function useLang() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const lang = params.get("lang");
  const supported = ["en", "ja", "ne", "zh", "ko"];
  return supported.includes(lang) ? lang : "en";
}

function useDarkMode() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const darkMode = params.get("dark");
  return darkMode === "true";
}

const TermsPage = () => {
  const lang = useLang();
  const isDarkMode = useDarkMode();

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  const termsContent = [
    {
      title: t(lang, ["terms", "sections", 1, "title"]),
      body: t(lang, ["terms", "sections", 1, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 2, "title"]),
      body: t(lang, ["terms", "sections", 2, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 3, "title"]),
      body: t(lang, ["terms", "sections", 3, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 4, "title"]),
      body: t(lang, ["terms", "sections", 4, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 5, "title"]),
      body: t(lang, ["terms", "sections", 5, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 6, "title"]),
      body: t(lang, ["terms", "sections", 6, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 7, "title"]),
      body: t(lang, ["terms", "sections", 7, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 8, "title"]),
      body: t(lang, ["terms", "sections", 8, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 9, "title"]),
      body: t(lang, ["terms", "sections", 9, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 10, "title"]),
      body: t(lang, ["terms", "sections", 10, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 11, "title"]),
      body: t(lang, ["terms", "sections", 11, "body"]),
    },
    {
      title: t(lang, ["terms", "sections", 12, "title"]),
      body: t(lang, ["terms", "sections", 12, "body"]),
    },
  ];

  const filteredTermsContent = termsContent.filter(
    (section) => !section.title.toLowerCase().includes("contact us")
  );

  const tick = (
    <span
      className="inline-block align-middle mr-2 text-green-600"
      style={{ fontSize: 18, fontWeight: 700 }}
      aria-label="tick"
    >
      ✓
    </span>
  );

  const floatingCardStyle = {
    background: "var(--sa-bg-primary)",
    borderRadius: "var(--ShresthaApp-border-radius)",
    boxShadow: "var(--sa-card-shadow)",
    transition: "box-shadow 0.3s, transform 0.2s, background-color 0.3s ease",
    position: "relative",
    zIndex: 1,
    willChange: "transform",
    margin: 16,
    cursor: "pointer",
    padding: 8,
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center py-0 px-0 pt-20"
      style={{
        background: "var(--sa-bg-secondary)",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
        color: "var(--sa-text-primary)",
        transition: "background-color 0.3s ease, color 0.3s ease",
      }}
    >
      <div
        className="w-full max-w-2xl flex flex-col items-center pt-20"
        style={{ paddingBottom: 0 }}
      >
        <h2
          className="text-2xl sm:text-3xl font-bold text-center"
          style={{ paddingTop: 30, color: "var(--sa-text-primary)" }}
        >
          {t(lang, ["terms", "title"])}
        </h2>
        <p
          className="text-xs mb-6 text-center"
          style={{ color: "var(--sa-text-tertiary)" }}
        >
          <time dateTime="2024-01-01">
            {t(lang, ["terms", "date"], "January 1, 2024")}
          </time>
        </p>
        <div className="w-full">
          {filteredTermsContent.map((section, idx) => (
            <div
              key={idx}
              style={{
                ...floatingCardStyle,
                marginBottom: 24,
                padding: 16,
              }}
            >
              <div>
                <h5
                  className="text-sm sm:text-base font-semibold mb-2 flex items-center"
                  style={{ color: "var(--sa-button-secondary)" }}
                >
                  {tick}
                  <span>{section.title.replace(/^\d+\.?\s*/, "")}</span>
                </h5>
                <p
                  className="whitespace-pre-line text-justify leading-relaxed"
                  style={{ color: "var(--sa-text-secondary)" }}
                >
                  {section.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Footer */}
      <InfoComponent />
    </div>
  );
};

export default TermsPage;
